import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { FaUserEdit, FaTrash } from "react-icons/fa";
import { Space, Table } from "antd";
import Modal from "react-bootstrap/Modal";
import { SpinnerCircular } from "spinners-react";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { render } from "@testing-library/react";
import moment from "moment";

const SearchApp = ({ data, loading, pagen, lastPage, deleteConfirmation }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  let couponDataList = data;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };

  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    couponDataList = couponDataList.filter(
      (e) =>
        e?.coupon_code?.toLowerCase().includes(searchString)
        // e?.price.toString().includes(searchString) ||
        // e?.duration.toString().includes(searchString) || 
        // e?.delivery_time.toString().includes(searchString)
    );
  }

  return (
    <div className="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div className="dashboard_header">
            <div className="left-side d-flex ">
              {" "}
              <button
                type="button"
                id="sidebarCollapse"
                className="btn btn-link bt_none"
              >
                <i className="fa fa-align-left"></i>{" "}
              </button>
              <h1>Coupon</h1>
            </div>
            <div className="user_profile">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <TableComponent
          data={couponDataList}
          loading={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={pagen}
          deleteConfirmation={deleteConfirmation}
        />
      </div>
    </div>
  );
};

const TableComponent = ({ deleteConfirmation, loading, data }) => {
  const columns = [
    {
      title: "Coupon Code",
      dataIndex: "coupon_code",
      key: "coupon_code",
      sorter: (a, b) => a.coupon_code.localeCompare(b.coupon_code),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      // width: "20%",
      key: "discount",
      sorter: (a, b) => a.discount - b.discount,
      render: (discount) => `${parseFloat(discount).toFixed(2)}%`,
    },
    {
      title: "Expiration Date",
      dataIndex: "expiration_date",
      key: "expiration_date",
      // sorter: (a, b) => new Date(a.expiration_date) - new Date(b.expiration_date),
      render:(expiration_date) => `${moment(expiration_date).format('DD MMM, YYYY')}`
    },
    {
      title: "Action",
      key: "action",
      // width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Link
            to="/edit-coupon-details"
            state={{
              couponId: record.id,
              couponDetails: record,
            }}
          >
            <FaUserEdit style={{ fontSize: "30px" }} />
          </Link>
       
          <FaTrash
            onClick={() =>
              deleteConfirmation(
                record.id,
                `${record.coupon_code}`
              )
            }
            style={{ fontSize: "30px" }}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="table_vedio_upload dashbord_table team_table mb_30 over_flow mb-0">
      <Table
        className="table table-borderless table-responsive-md"
        columns={columns}
        // rowSelection={{ ...rowSelection, checkStrictly }}
        dataSource={data}
        loading={loading}
        pagination={{ defaultPageSize: 20 }}
        rowKey="id"
      />
      <ToastContainer />
    </div>
  );
};

const UserInput = ({ update, handlePage }) => {
  return (
    <div className="analysts-wraper-head">
      <div className="form-group search_wraper">
        <input
          onChange={(e) => {
            update(e);
            handlePage(0);
          }}
          name=""
          className="form-control custom_input"
          placeholder="Search here"
        />
      </div>
      <div className="map_btn">
        <Link
          to="/edit-coupon-details"
          state={{
            couponId: undefined,
            couponDetails: [],
          }}
          className="them_btn"
        >
          Add Coupon
        </Link>
      </div>
    </div>
  );
};

export default function Coupon() {
  const token = localStorage.getItem("xAuthToken");
  const [couponData, setCouponData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  const [couponID, setCouponID] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const [deleteMessage, setDeleteMessage] = useState(
    "are you sure you want to delete?"
  );

  const deleteConfirmation = (id, name) => {
    setCouponID(id);
    setDeleteMessage(
      `Are you sure you want to delete ${name}?`
    );
    setShowModal(true);
  };

  const DeleteCoupon = async () => {
    setLoading(true);

    http
      .delete(`api/admin/delete-coupon/${couponID}?token=${token}`)
      .then((res) => {
        setCouponID(0);
        setLoading(false);
        getAllCouponDetails();
        handleClose();
        showToast("success", res.data.message);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllCouponDetails();
  }, []);

  const getAllCouponDetails = async () => {
    setLoading(true);

    http
      .get(`api/admin/coupon/code-details?token=${token}`)
      .then((res) => {
        setLoading(false);
        setCouponData(res.data);
        setLastPageNumber(res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <SearchApp
        data={couponData}
        loading={loading}
        pagen={lastPageNumber}
        lastPage={lastPage}
        deleteConfirmation={deleteConfirmation}
      />
      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Are you sure?</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="raing_star">
            <p>{deleteMessage}</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleClose}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={DeleteCoupon}
              disabled={loading}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {loading ? <SpinnerCircular /> : " Yes"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
